import { DecimalMath } from "../decimal-utils";
const CONVERSION_FACTORS_TO_J = {
    J: 1,
    Wh: 3600, // 1 Wh = 3600 J
    kWh: 3600000, // 1 kWh = 1000 Wh = 3,600,000 J
    MWh: 3600000000, // 1 MWh = 1000 kWh = 3,600,000,000 J
};
/**
 * Convert energy value from one unit to another
 * @param value - The value to convert
 * @param fromUnit - The source unit
 * @param toUnit - The target unit
 * @returns The converted value
 */
export function convertEnergy(value, fromUnit, toUnit) {
    // Convert to base unit (Joules) first
    const valueInJoules = value * CONVERSION_FACTORS_TO_J[fromUnit];
    // Then convert to target unit
    return valueInJoules / CONVERSION_FACTORS_TO_J[toUnit];
}
/**
 * Convert energy value to Joules
 * @param value - The value to convert
 * @param fromUnit - The source unit
 * @returns The value in Joules
 */
export function toJoules(value, fromUnit) {
    return value * CONVERSION_FACTORS_TO_J[fromUnit];
}
/**
 * Convert energy value from Joules to another unit
 * @param joules - The value in Joules
 * @param toUnit - The target unit
 * @returns The converted value
 */
export function fromJoules(joules, toUnit) {
    return joules / CONVERSION_FACTORS_TO_J[toUnit];
}
export const convertJToMWh = (value) => {
    const result = value / 3600000000;
    return DecimalMath.round(result, 2);
};
/**
 * Convert t CO₂äq/MWh to kg CO₂äq/J
 * @param value - Value in t CO₂äq/MWh
 * @returns Value in kg CO₂äq/J
 */
export function convertTPerMwhToKgPerJ(value) {
    // 1 t = 1000 kg, 1 MWh = 3,600,000,000 J
    return (value * 1000) / 3600000000;
}
/**
 * Convert tonnes to kilograms
 * @param value - Value in tonnes
 * @returns Value in kilograms
 */
export function convertTToKg(value) {
    return value * 1000;
}
